// Objetivos táctiles ≥ 44 px solo donde se opera con el dedo (pantallas del
// líder en tableta). `LiderLayout` provee `true`; fuera de él (supervisor,
// coordinador) el valor es `false` y los componentes compartidos conservan sus
// tamaños compactos de siempre.

import { createContext, useContext, type ReactNode } from 'react';

const TouchTargetsContext = createContext(false);

export function TouchTargetsProvider({ children }: { children: ReactNode }) {
  return <TouchTargetsContext.Provider value>{children}</TouchTargetsContext.Provider>;
}

/** `true` si el componente se renderiza dentro del layout del líder. */
export function useTouchTargets(): boolean {
  return useContext(TouchTargetsContext);
}
